import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { CohortBucket, CohortSignal } from "../api/types";

/**
 * Такт опроса теневого журнала перевеса группы.
 *
 * Тот же, что у соседних теневых сигналов, и по той же причине: кнопок у
 * раздела нет, решений по нему не принимают, и секунда задержки ничего не
 * стоит. Строк здесь по построению не больше двух на окно, а окна закрываются
 * раз в пять минут.
 */
const COHORT_REFETCH_MS = 15_000;

/** Сводка перевеса группы, разрезом по минуте окна. */
export function useCohortSummary(hours: number, windowLen = 0) {
  return useQuery<{ hours: number; buckets: CohortBucket[] }>({
    queryKey: ["cohort-summary", hours, windowLen],
    queryFn: () => api.cohortSummary(hours, windowLen),
    refetchInterval: COHORT_REFETCH_MS,
    retry: 1,
  });
}

/**
 * Лента теневых ставок, свежие сверху.
 *
 * Погашенные правилом строки НЕ прячутся: они и есть ответ на вопрос «сколько
 * мы пропустили и почему», без которого пороги калибруются вслепую.
 */
export function useCohortSignals(hours: number, limit = 60, windowLen = 0) {
  return useQuery<{ signals: CohortSignal[] }>({
    queryKey: ["cohort-signals", hours, limit, windowLen],
    queryFn: () => api.cohortSignals(hours, limit, undefined, windowLen),
    refetchInterval: COHORT_REFETCH_MS,
    retry: 1,
  });
}
